import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-number-picker',
  templateUrl: './number-picker.component.html',
  styleUrls: ['./number-picker.component.scss'],
  standalone: false,
})
export class NumberPickerComponent implements OnInit {
  @Input() min: number;
  @Input() max: number;
  @Input() currencyPicker: boolean = false;
  @Output() selectedValues = new EventEmitter<{ min: number; max: number }>();
  numberPickerFormGroup: FormGroup;
  currencySymbol = environment.currency_symbol;

  constructor() {}

  ngOnInit(): void {
    this.numberPickerFormGroup = new FormGroup({
      min: new FormControl(this.min, [Validators.min(0)]),
      max: new FormControl(this.max, [Validators.min(0)]),
    });
  }

  emitSelection() {
    this.selectedValues.emit({
      min: this.numberPickerFormGroup.value.min,
      max: this.numberPickerFormGroup.value.max,
    });
  }
}
